
jQuery(document).ready(function ($) {

    $('.user-menu-container').hover(function() {
    $(this).find('.login-drop-menu').stop(true, true).show();
}, function() {
    $(this).find('.login-drop-menu').stop(true, true).hide();
    });
});


jQuery(document).ready(function ($) {

    $('.campaign-menu-container').hover(function() {
        $(this).find('.campaign-drop-menu').stop(true, true).delay(10).fadeIn(100);
    }, function() {
        $(this).find('.campaign-drop-menu').stop(true, true).delay(200).fadeOut(500);
    });
});
